var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns session-responsive" }, [
    _c("div", { staticClass: "column is-one-third view-filter" }, [
      _c("p", { staticClass: "hint" }, [
        _c("i", {
          staticClass: "fad fa-arrows-h pointer",
          attrs: { title: "Expand types" },
          on: {
            click: function($event) {
              _vm.long = !_vm.long
            }
          }
        }),
        _vm._v(" "),
        !_vm.long
          ? _c("span", { staticClass: "white-space: nowrap;" }, [
              _vm._v(_vm._s(_vm.hint))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tags session-types" },
        _vm._l(_vm.sessionTypes, function(sessionType, index) {
          return _c(
            "span",
            {
              staticClass: "tag is-dark",
              attrs: { title: sessionType.name },
              on: {
                click: function($event) {
                  return _vm.addToTypes(sessionType)
                },
                mouseover: function($event) {
                  _vm.hint = sessionType.name
                },
                mouseleave: function($event) {
                  _vm.hint = ""
                }
              }
            },
            [
              _vm.long
                ? _c("span", [_vm._v(_vm._s(sessionType.name))])
                : _vm._e(),
              _vm._v(" "),
              !_vm.long
                ? _c("span", [
                    _vm._v(_vm._s(sessionType.short_name || sessionType.name))
                  ])
                : _vm._e()
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("p", [
        _c("small", [_vm._v("Local " + _vm._s(_vm.event.timezone))]),
        _vm._v(":")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tags session-types" },
        _vm._l(_vm.localDays, function(localDay, index) {
          return _c(
            "span",
            {
              staticClass: "tag is-info",
              attrs: { title: localDay.name },
              on: {
                click: function($event) {
                  return _vm.addToDays(localDay)
                }
              }
            },
            [_vm._v("\n          " + _vm._s(localDay.format) + "\n        ")]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "column is-two-thirds view-list" }, [
      _c("h1", [_vm._v("Quick Lookup")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "By default, quick lookup starts from sessions that have recently started."
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.search,
            expression: "search"
          }
        ],
        staticClass: "input",
        attrs: {
          type: "text",
          placeholder: "Search by title, id, content, or presenter"
        },
        domProps: { value: _vm.search },
        on: {
          keyup: _vm.searchSessions,
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.search = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tags" },
        [
          _vm.search
            ? _c("span", { staticClass: "tag is-info" }, [
                _vm._v("\n          " + _vm._s(_vm.search) + "\n          "),
                _c("button", {
                  staticClass: "delete is-small",
                  on: { click: _vm.resetSearch }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.selectedTypes, function(selectedType, index) {
            return _c("span", { staticClass: "tag is-success" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.sessionTypeNameById(selectedType)) +
                  "\n          "
              ),
              _c("button", {
                staticClass: "delete is-small",
                on: {
                  click: function($event) {
                    return _vm.removeFromTypes(selectedType)
                  }
                }
              })
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.selectedDays, function(selectedDay, index) {
            return _c("span", { staticClass: "tag is-default" }, [
              _vm._v("\n          " + _vm._s(selectedDay) + "\n          "),
              _c("button", {
                staticClass: "delete is-small",
                on: {
                  click: function($event) {
                    return _vm.removeFromDays(selectedDay)
                  }
                }
              })
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.selectedPresenters, function(selectedPresenter, index) {
            return _c("span", { staticClass: "tag is-warning" }, [
              _vm._v(
                "\n          " + _vm._s(selectedPresenter.name) + "\n          "
              ),
              _c("button", {
                staticClass: "delete is-small",
                on: {
                  click: function($event) {
                    return _vm.removeFromPresenters(selectedPresenter)
                  }
                }
              })
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticStyle: { "margin-top": "20px" } },
        _vm._l(_vm.sessions, function(session, index) {
          return _c(
            "li",
            { key: session.id, staticClass: "session-overview" },
            [
              _c("div", { staticClass: "columns" }, [
                _c(
                  "div",
                  { staticClass: "column is-1 is-hidden-mobile" },
                  _vm._l(session.participants, function(p) {
                    return _c("div", { staticClass: "session-presenter" }, [
                      _c("figure", {
                        staticClass: "image",
                        domProps: { innerHTML: _vm._s(_vm.avatarImage(p)) }
                      })
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "column is-11" }, [
                  _c("h1", { staticClass: "session-title" }, [
                    _c("a", { attrs: { href: _vm.sessionLink(session.id) } }, [
                      _vm._v(_vm._s(session.title))
                    ]),
                    _vm._v(" "),
                    _c("small", [_vm._v("#" + _vm._s(session.id))]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa-heart",
                      class: _vm.fasClasses(session),
                      on: {
                        click: function($event) {
                          return _vm.toggle(session)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "session-time" }, [
                    _vm._v(
                      _vm._s(_vm.getTime(session.starts_at, session.ends_at)) +
                        " "
                    ),
                    _c("strong", [_vm._v(" | ")]),
                    _vm._v(
                      "\n               " + _vm._s(_vm.getLocationName(session))
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "session-description" }, [
                    _vm._v(_vm._s(session.description))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "session-type" }, [
                    _vm._v(_vm._s(_vm.sessionTypeName(session)))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "session-presenters" },
                    _vm._l(session.participants, function(p) {
                      return _c("span", { staticClass: "session-presenter" }, [
                        _c(
                          "span",
                          {
                            class: _vm.pClass(p),
                            on: {
                              click: function($event) {
                                return _vm.addToPresenters(p)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                      " +
                                _vm._s(_vm.participantName(p))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "delimiter" }, [
                          _vm._v(" / ")
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("You can also "),
      _c("a", { attrs: { href: "/schedule/index" } }, [
        _vm._v("view the schedule")
      ]),
      _vm._v(".")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }